import { HostBinding, Directive } from '@angular/core';
@Directive()
export class ContainerSettings {
  @HostBinding('class.contains-max-width')
  handleMaxWidthSelf = true;
}
